import { createContext } from "react";

import type { BottomBarOverrideContextValue } from "./types";

export const BottomBarOverrideContext =
  createContext<BottomBarOverrideContextValue | null>(null);
BottomBarOverrideContext.displayName = "BottomBarOverrideContext";
